import { GeoPicker, Select } from "components/shared/form";
import { requiredField } from "helpers/validators";
import React, { useEffect, useState } from "react";
import { components } from "react-select";

import { list as getItemChangePoints } from "sources/books/itemChangePoints";
import ItemChangePointsAddresses from "./ItemChangePointsAddresses";

const CargoOwnerPointOption = (props) => {
    const { name, geozone } = props.data.option;

    return (
        <components.Option {...props}>
            {name}
            <small className="text-muted pl-1">{geozone.address}</small>
        </components.Option>
    );
};

const CargoOwnerPointValueContainer = (props) => {
    const { children, getValue, hasValue } = props;

    if (!hasValue) {
        return <components.ValueContainer {...props} />;
    }

    const value = getValue()[0];

    if (!value || !value.option) {
        return <components.ValueContainer {...props} />;
    }

    const { geozone } = value.option;

    return (
        <components.ValueContainer {...props}>
            {!props.selectProps.inputValue && (
                <components.SingleValue {...props}>
                    <div>
                        {value.label}
                        <small className="text-muted pl-1">{geozone.address}</small>
                    </div>
                </components.SingleValue>
            )}
            {children[children.length - 1]}
        </components.ValueContainer>
    );
};

const ACTIONS = {
    INIT: "INIT",
    SELECT_TRUCKING_BIDS_IN_SELECT: "SELECT-COUNTERPARTY-IN-SELECT",
    SELECT_TRUCKING_BIDS_IN_TABLE: "SELECT-COUNTERPARTY-IN-TABLE",
};

const AddressPicker = (props) => {
    const { onChange, mapObject, addModal, switchMap, label = "Локация смены составляющих" } = props;

    const [action, setAction] = useState(ACTIONS.INIT);
    const [addressSelectValue, setAddressSelectValue] = useState(null);
    const [pointSaved, setPointSaved] = useState(false);

    useEffect(() => {
        setPointSaved(false);
    }, [mapObject?.address]);

    const selectItemChangePoints = (e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();

        setAction(ACTIONS.SELECT_TRUCKING_BIDS_IN_SELECT);
    };

    const selectOnMap = (e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();

        setAction(ACTIONS.INIT);

        switchMap();
    };

    const back = (e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();

        setAction(ACTIONS.INIT);
    };

    const setItemChangePointsAddressValue = ({ name, value }) => {
        onChange({ name, value: value?.geozone });
    };
    const openItemChangePointsAddressesModal = () => {
        addModal({
            name: "default",
            title: "Список адресов перецепок",
            CustomBody: ItemChangePointsAddresses,
            windowMod: "lg d-flex",
            bodyData: {
                onChange: setItemChangePointsAddressValue,
            },
        });
    };

    const saveCounterpartyAddress = (e) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();

        addModal({
            name: "itemChangePointForm",
            title: "Сохранение адреса перецепки",
            mapObject,
            successCallback: (res) => {
                if (res) {
                    setPointSaved(true);
                    setAddressSelectValue(res.id);
                    return Promise.resolve(true);
                } else {
                    return Promise.resolve(false);
                }
            },
        });
    };

    switch (action) {
        case ACTIONS.INIT: {
            const showSavePoint = !pointSaved && mapObject?.address;

            const inputBottomText = (
                <>
                    <small className="link d-block" onClick={selectItemChangePoints}>
                        Выбрать из списка адресов перецепок
                    </small>
                    {showSavePoint && (
                        <small className="link d-block" onClick={saveCounterpartyAddress}>
                            Сохранить адрес для перецепки
                        </small>
                    )}
                </>
            );

            return (
                <GeoPicker
                    label={label}
                    name="mapObject"
                    switchMap={switchMap}
                    onChange={onChange}
                    value={mapObject}
                    validators={[requiredField]}
                    inputBottomText={inputBottomText}
                />
            );
        }
        case ACTIONS.SELECT_TRUCKING_BIDS_IN_SELECT: {
            const selectItemChangePointsInTable = (e) => {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();

                setAction(ACTIONS.SELECT_TRUCKING_BIDS_IN_TABLE);

                openItemChangePointsAddressesModal();
            };

            const setAddressValueWithOption = ({ name, value, option }) => {
                setAddressSelectValue(value);

                onChange({ name, value: option.geozone });
            };

            const inputBottomText = (
                <>
                    <small className="link d-block" onClick={selectItemChangePointsInTable}>
                        Выбрать адрес перецепки в табличном представлении
                    </small>
                    <small className="link d-block" onClick={selectOnMap}>
                        Выбрать на карте
                    </small>
                    <small className="link d-block" onClick={back}>
                        ← Назад
                    </small>
                </>
            );

            return (
                <Select
                    wrapper="book-field"
                    fieldWrapper="col-sm-8 col-md-9"
                    inputProps={{
                        name: "mapObject",
                    }}
                    propName="name"
                    url={getItemChangePoints}
                    onChange={setAddressValueWithOption}
                    value={addressSelectValue}
                    required
                    unClearable
                    validators={[requiredField]}
                    label="Адрес"
                    inputBottomText={inputBottomText}
                    components={{ Option: CargoOwnerPointOption, ValueContainer: CargoOwnerPointValueContainer }}
                />
            );
        }
        case ACTIONS.SELECT_TRUCKING_BIDS_IN_TABLE: {
            const selectItemChangePointsInSelect = (e) => {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();

                setAction(ACTIONS.SELECT_TRUCKING_BIDS_IN_SELECT);
            };

            const inputBottomText = (
                <>
                    <small className="link d-block" onClick={selectItemChangePointsInSelect}>
                        Выбрать адрес перецепки из списка
                    </small>
                    <small className="link d-block" onClick={selectOnMap}>
                        Выбрать на карте
                    </small>
                    <small className="link d-block" onClick={back}>
                        ← Назад
                    </small>
                </>
            );

            return (
                <GeoPicker
                    label={label}
                    name="mapObject"
                    switchMap={() => openItemChangePointsAddressesModal()}
                    onChange={setItemChangePointsAddressValue}
                    value={mapObject}
                    validators={[requiredField]}
                    inputBottomText={inputBottomText}
                />
            );
        }
        default: {
            return null;
        }
    }
};

export default AddressPicker;
